import React from 'react';
import DropDownOption from 'src/view/components/Controls/Pickers/components/DropDownOption/DropDownOption';
import { TGoogleAddress } from 'src/view/components/AddressSearch/AddressSearch';

interface IProps {
  address: TGoogleAddress;
  onSelect: (addr: string) => void;
}

const PlacesListOption = ({ address, onSelect }: IProps) => {
  return (
    <DropDownOption<string> key={address.placeId} value={address.desc} onClick={onSelect}>
      <span className="text-size-16 family-semibold">{address.desc}</span>
    </DropDownOption>
  );
};

export default React.memo(PlacesListOption);
